module.exports = __webpack_public_path__ + "img/logo-referencia.11871e67.svg";